import { DeleteOutlined } from '@ant-design/icons'
import { Button, Flex, Modal, Table, Tag } from 'antd'
import { ModalProps, TableColumnsType } from 'antd/lib'
import { useMemo } from 'react'

import { DocumentTextIcon } from 'src/assets'
import { SearchBar, Text } from 'src/components'
import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'

import { data, people } from '../data'

type Props = {
  id: number
  onCancel: () => void
} & ModalProps

export const AddPeopleModal = ({ id, onCancel, ...props }: Props) => {
  const { t } = useLocales()
  const pagination = useTablePagination()

  const currentItem = data.find((item) => item.id === id)

  const columns = useMemo(
    (): TableColumnsType => [
      {
        key: 'name',
        title: `${t('form.last_name')} ${t('form.first_name')}`,
        dataIndex: 'name'
      },
      {
        key: 'idnp',
        title: t('form.idnp'),
        dataIndex: 'idnp'
      },
      {
        key: 'status',
        title: t('form.status'),
        render: ({ status }) => {
          const isActive = status === 'active'

          return (
            <Tag color={isActive ? 'success' : 'error'}>
              {isActive
                ? t('common.active')
                : t('support_investigation.not_analyzed')}
            </Tag>
          )
        }
      },
      {
        key: 'delete',
        render: ({ id }) => (
          <Button danger onClick={() => alert(id)} icon={<DeleteOutlined />} />
        )
      }
    ],
    [t]
  )

  return (
    <Modal
      open
      centered
      onCancel={onCancel}
      maskClosable={false}
      width={800}
      title={
        <Text size="xxl" weight={700}>
          {currentItem?.name}
        </Text>
      }
      footer={
        <Flex justify="center">
          <Button type="primary" onClick={onCancel}>
            {t('common.save')}
          </Button>
        </Flex>
      }
      {...props}
    >
      <Flex vertical gap={24}>
        <Flex justify="space-between" gap={20}>
          <SearchBar onSearch={() => null} />

          <Button icon={<DocumentTextIcon />}>
            {t('support_investigation.upload_idnp')}
          </Button>
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          scroll={{ x: 'max-content' }}
          dataSource={people}
          pagination={{ ...pagination, total: people.length }}
        />
      </Flex>
    </Modal>
  )
}
